import { type ReactElement } from 'react';

import { Box, Typography } from '@mui/material';

import AnychartProgress from '../anychart-progress';

type PreloaderProps = {
  title?: string;
  size?: number | 'small' | 'medium' | 'large';
};

export default function Preloader({ title, size = 'medium' }: PreloaderProps): ReactElement {
  return (
    <Box
      component="main"
      sx={{
        display: 'grid',
        height: '100%',
        width: '100%',
        placeContent: 'center',
      }}
    >
      {title && <Typography variant="h4" gutterBottom>{title}</Typography>}
      <AnychartProgress size={size} />
    </Box>
  );
}
